import { useState, useEffect } from "react";
import HamburgerComponent from "./HamburgerComponent";
import { useNavigate } from 'react-router-dom';
import configData from '../config.json';

const BaseHeaderComponent = ({children, categoryList, setActiveCategory, activeCategory, setActiveVideo}) => {

    useEffect(() => {

        $('.d-overlay').on('click', function () {
            $('.offcanvas-collapse').toggleClass('open');
            $('body').toggleClass('opened-menu')
         })
    
         $('#navbarSideCollapse').on('click', function (e) {
            $('.offcanvas-collapse').toggleClass('open');
            $('body').toggleClass('opened-menu')
        })

        $('.d-sidelinks').on('click', function () {
            $('.offcanvas-collapse').toggleClass('open');
            $('body').toggleClass('opened-menu');
         })

    }, []);

    let navigate = useNavigate(); 
    const navigateTo = () =>{ 
        navigate("/");
    }

    if((configData.BRAND).toUpperCase() === 'DELO'){
        var imgSrcBrand = configData.DELO.LOGO;
        var altImgBrand = configData.DELO.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-delo-logo";
        var linkTitle = configData.DELO.HAMBURGER_LINK_TITLE;
        var link = configData.DELO.HAMBURGER_LINK;
    }
    else {
        var imgSrcBrand = configData.SLOVENSKENOVICE.LOGO;
        var altImgBrand = configData.SLOVENSKENOVICE.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-novice-logo";
        var linkTitle = configData.SLOVENSKENOVICE.HAMBURGER_LINK_TITLE;
        var link = configData.SLOVENSKENOVICE.HAMBURGER_LINK;
    }

    return (
        <>
            <nav id="header" className="navbar fixed-top navbar-light" aria-label="Main navigation">

                <div className="container d-navbar-content position-relative justify-content-center flex-column">
                <a className="navbar-brand" href="#" onClick={navigateTo}>
                          <img src={imgSrcBrand} className={imgClassNameBrand} alt={altImgBrand}/>
                        </a>

                    {/* <button className="navbar-toggler p-0 border-0 fade-in-image" type="button" id="navbarSideCollapse" onClick={navHamburgerButtonClicked} aria-label="Toggle navigation" > */}
                    <button className="navbar-toggler p-0 border-0 fade-in-image" type="button" id="navbarSideCollapse" aria-label="Toggle navigation" >
                        <span className="icon-bar top-bar"></span>
                        <span className="icon-bar middle-bar"></span>
                        <span className="icon-bar bottom-bar"></span>
                    </button>

                    <div className="d-header-left-buttons">

                    {/* <button className="d-header-search" type="button" id="headerSearch" aria-label="Search">
                        <i className="fa-regular fa-magnifying-glass"></i>
                    </button> */}

                    <a href={link} target={"_blank"} className="d-powered-by-link">{linkTitle}</a>
                    </div>

                    {/* <button className="d-header-search" type="button" id="headerSearch" aria-label="Search">
                        <i className="fa-regular fa-magnifying-glass"></i>
                    </button> */}

                    {/* <div className="d-header-buttons">
                        <button type="button" className="btn btn-primary d-btn-user"><i className="fa-regular fa-user"></i> <span className="d-text">Prijava</span></button>
                        <button type="button" className="btn btn-primary d-btn-register"><i className="fa-regular fa-user-plus"></i> <span className="d-text">Registracija</span></button>
                    </div> */}

                    {/* <div className="d-overlay" onClick={navHamburgerButtonClicked}></div> */}
                    <div className="d-overlay"></div>


                    <HamburgerComponent categoryList={categoryList} setActiveCategory={setActiveCategory} activeCategory={activeCategory} setActiveVideo={setActiveVideo}></HamburgerComponent>

                </div>
                {children}
            </nav>
        </>
    );
};

export default BaseHeaderComponent;